<template>
  <div class="address-component">
    <el-button
      class="add-btn"
      :disabled="addressList && addressList.length >= 5"
      @click="handleAddAddress"
    >
      添加地址
    </el-button>
    <div class="address-list" v-if="addressList && addressList.length">
      <div
        class="address-item"
        v-for="(item, index) in addressList"
        :key="item.id"
      >
        <div class="name-area">
          <span class="name">{{ item.name }}</span>
          <span class="phone">{{ item.mobile }}</span>
        </div>
        <div class="address-area">
          <div class="address">
            {{ item.province + item.city + item.district + item.address }}
          </div>
          <div class="handle-box">
            <img
              src="../../../assets/images/user-info/edit_icon.png"
              alt=""
              @click="handleEdit(item, index)"
            />
            <img
              src="../../../assets/images/user-info/delete_icon.png"
              alt=""
              @click="handleDelete(item, index)"
            />
          </div>
        </div>
        <div class="default-tag" v-if="item.is_default">默认地址</div>
      </div>
    </div>
    <el-empty
      v-else
      description="暂无内容"
      :image="require('@/assets/img/live-list/empty.png')"
    ></el-empty>
    <edit
      ref="edit"
      :addressInfo="editAddressInfo"
      @success="successEdit"
    ></edit>
  </div>
</template>

<script>
import Edit from "@saas/components/src/components/address/Edit.vue";
import {
  getAddressList,
  deleteAddress,
} from "@saas/service-api/src/address/index.js";

export default {
  data() {
    return {
      addressList: [],
      editAddressInfo: {},
    };
  },
  mounted() {
    this.getAddressList();
  },
  methods: {
    handleAddAddress() {
      if (this.addressList.length >= 5) {
        return;
      }
      this.editAddressInfo = {};
      this.$refs.edit.open();
    },
    handleDelete(address) {
      this.$confirm("是否确认删除此地址信息？", "提示", {
        confirmButtonText: "确 定",
        cancelButtonText: "取 消",
        type: "warning",
      }).then(() => {
        deleteAddress({ id: address.id }).then((res) => {
          if (res.code === 1) {
            this.$message.success("删除成功");
            this.getAddressList();
          } else {
            this.$message.error(res.msg);
          }
        });
      });
    },
    handleEdit(address) {
      this.editAddressInfo = address;
      this.$refs.edit.open();
    },
    getAddressList() {
      getAddressList().then((res) => {
        if (res.code === 1) {
          this.addressList = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    successEdit() {
      this.$message.success("保存成功");
      this.getAddressList();
    },
  },
  components: {
    Edit,
  },
};
</script>

<style scoped lang="scss">
.address-component {
  background: var(--card-bg, #ffffff);
  border-radius: 16px;
  flex: 1;
  padding: 18px;
  .add-btn {
    background: unset;
    width: 80px;
    height: 30px;
    border-radius: 8px;
    border: 1px solid #00c89d;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #00c89d;
    font-weight: 400;
    font-size: 14px;
    color: #00c89d;
    &.is-disabled {
      color: var(--disabled-text, #ebeef5);
      border-color: var(--disabled-bg, #ebeef5);
    }
  }
  .address-list {
    margin-top: 4px;
    .address-item {
      position: relative;
      min-height: 90px;
      border-radius: 12px;
      border: 1px solid var(--border-color, #e5e6e8);
      margin-top: 14px;
      padding: 18px 20px 0 18px;
      &:hover {
        .handle-box {
          display: flex !important;
        }
      }
      .name-area {
        .name {
          font-weight: 600;
          font-size: 14px;
          color: var(--text-primary, #0d1400);
          line-height: 22px;
        }
        .phone {
          font-weight: 400;
          font-size: 14px;
          color: var(--text-primary, #0d1400);
          line-height: 22px;
          margin-left: 21px;
        }
      }
      .address-area {
        display: flex;
        justify-content: space-between;
        margin-top: 11px;
        .address {
          font-weight: 400;
          font-size: 14px;
          color: var(--text-primary, #0d1400);
          line-height: 22px;
          padding-bottom: 18px;
        }
        .handle-box {
          display: none;
          img {
            width: 24px;
            height: 24px;
            cursor: pointer;
            &:not(:last-child) {
              margin-right: 15px;
            }
          }
        }
      }
      .default-tag {
        position: absolute;
        top: 6px;
        right: 9px;
        width: 80px;
        height: 32px;
        line-height: 32px;
        text-align: center;
        background: rgba(0, 200, 157, 0.1);
        border-radius: 8px;
        font-weight: 500;
        font-size: 14px;
        color: #00c89d;
      }
    }
  }
}
</style>
